export const ActiveUploadsEnum = {
  ADD_UPLOAD: 'addUpload',
  REMOVE_UPLOAD: 'removeUpload',
  REMOVE_UPLOADS: 'removeUploads',
  UPDATE_UPLOAD: 'updateUploads'
}